<template>
  <VContainer class="have-30-years-page">
    <VRow>
      <VCol cols="12">
        <div class="have-30-years-page__content">
          <p>
            You may NOT need 35 years on your National Insurance record to maximise your UK State Pension entitlement.
          </p>
          <p>
            People who have worked 10-20 years in the UK frequently may only need 28 or 29 years in total to get a full
            UK State Pension.
          </p>
          <p>Buying more years than you need is just wasting money and no refunds are possible in this case.</p>
          <p>
            If you have (/ will have after paying) Voluntary Contributions to get close to approx. 30 years or more on
            your record, <b>we STRONGLY RECOMMEND that you call DWP to double-check</b> the total number of years you
            need to reach the maximum UK Pension amount
          </p>
          <p class="text-center">
            Call <a href="tel:+441912183600">+44 191 218 3600</a> if you're <b>UNDER </b>
            <a href="https://www.gov.uk/state-pension-age/y/age">UK State Pension age</a> <br />
            or <a href="tel:+441912187777">+44 191 218 7777</a> if you're <b>OVER</b> it.
          </p>
          <p>This is a precaution to ensure you do not overpay HMRC in error.</p>
          <p>
            <i
              >(Unfortunately we’re not able to do this for you with DWP but we can speak to HMRC on your behalf
              regarding other matters)</i
            >
          </p>
        </div>
      </VCol>
    </VRow>
  </VContainer>
</template>
<script>
import { mapActions } from 'vuex';
// Utils
export default {
  name: 'Have30YearsPage',
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    ...mapActions('main', ['showSnackbar'])
  }
};
</script>
